import { CaseState } from 'app/area/case/types-store';
import { createDescriptionSelector } from 'app/infrastructure/translate';

export type CopyIteratorTranslations = { make, copies, createCopies, copy, cancel };

const translate: CopyIteratorTranslations = {
  make: 8108,
  copies: 8109,
  createCopies: 8110,
  copy: 7842,
  cancel: 3273
};
/**
 * Injects props for the feature "copy" [iterator]
 *
 * @param state
 * @param uiEngineProps
 */
export const copyIteratorProps = (
  state: CaseState
) => {
  const {texts} = state;
  const result = {};
  const getText = createDescriptionSelector(texts);
  Object.keys(translate).forEach(t => result[t] = getText(translate[t]));
  return {
    copyIterator: result
  };
};
